import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import Button from '../../components/Button';
import FlashMessage from '../../components/FlashMessage';
import Modal from '../../components/Modal/index';
import { Header3, P2 } from '../../components/Typography';
import { UNBLOCK_TENANT_STORE_KEY, unblockTenantRequested } from '../../redux/user/user.actions';
import { FLASH_MESSAGE_TIMEOUT, useFlashMessage } from '../FlashMessage';

interface UnblockTenantModalProps {
  email: string;
  isLoading: boolean;
  onDismiss: () => void;
}

const ActionBar = styled.div`
  display: flex;
  padding: 24px 0;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 10px;

  button {
    margin-right: 10px;
  }
`;

export const UnblockTenantModal: React.FC<UnblockTenantModalProps> = ({ onDismiss, email, isLoading }) => {
  const dispatch = useDispatch();
  const [flashMessage, onDismissFlashMessage] = useFlashMessage([UNBLOCK_TENANT_STORE_KEY]);

  return (
    <Modal onDismiss={onDismiss}>
      {flashMessage ? (
        <FlashMessage payload={flashMessage} onDismiss={onDismissFlashMessage} timeRemaining={FLASH_MESSAGE_TIMEOUT} />
      ) : null}
      <Header3>Unblock tenant</Header3>
      <P2>{`This will allow ${email} to be added to new Reposits.`}</P2>
      <ActionBar>
        <Button disabled={isLoading} buttonType="warning" onClick={onDismiss}>
          Cancel
        </Button>
        <Button disabled={isLoading} onClick={() => dispatch(unblockTenantRequested({ email }))}>
          Unblock tenant
        </Button>
      </ActionBar>
    </Modal>
  );
};
